import { Button, Icon, Modal } from '@octano/global-ui';
import { forwardRef, useImperativeHandle, useState } from 'react';
import { Col, Container, Row } from 'reactstrap';
import { SpecialtyArea } from '../../type';

interface Props {
  onConfirm: (data: SpecialtyArea) => void;
}

export interface ConfirmModalRef {
  openModal: (row: SpecialtyArea) => void;
  closeModal: () => void;
}

const ConfirmDeleteModal = forwardRef<ConfirmModalRef, Props>(
  ({ onConfirm }, ref) => {
    const [data, setData] = useState<SpecialtyArea>();

    const [modal, setModal] = useState(false);

    useImperativeHandle(ref, () => ({
      openModal(row: SpecialtyArea) {
        setData(row);
        setModal(true);
      },
      closeModal() {
        setModal(false);
      },
    }));

    return (
      <Modal isOpen={modal} toggle={() => setModal(!modal)}>
        <Container fluid className="text-center">
          <Icon name="information" size={45} />
          <h1 className="text-dark fs-20 mt-3 mb-4">
            ¿Realmente quieres eliminar esta área de especialidad?
          </h1>

          <Row className="d-flex justify-content-around mt-5">
            <Col xs={12} md={6}>
              <Button
                text="Aceptar"
                onClick={() => {
                  onConfirm(data!);
                  setModal(false);
                }}
                fullwidth
              />
            </Col>
            <Col xs={12} md={6}>
              <Button
                outlined
                text="Cancelar"
                onClick={() => {
                  setModal(false);
                }}
                fullwidth
              />
            </Col>
          </Row>
        </Container>
      </Modal>
    );
  },
);

export default ConfirmDeleteModal;
